module.exports = __webpack_public_path__ + "media/images/plus-86bef5f6def4aff9055eefc3d8ffcf33.svg";